import { AKA_UNION_TO_BUY_MORE_INSURANCES_PATH } from 'Constants/url.constants';
import { Brand, Union } from '../app/themes/themes.types';

export const getBasePath = (): string => window.location.pathname.split('/')[1];

export function linkPath(path: string, external?: boolean): string {
  if (process.env.NODE_ENV === 'development') {
    if (external) {
      return `https://www-t.storebrand.no/${path}`.replace(/\/\/+/g, '/');
    }
    return `/${path}`.replace(/\/\/+/g, '/');
  }
  return path;
}

export function getBuyMoreInsurancesLink(brand: Brand, union: Union): string {
  switch (brand) {
    case 'akademikerne':
      return linkPath(
        union
          ? `/akademikerne/${AKA_UNION_TO_BUY_MORE_INSURANCES_PATH[union]}`
          : '/akademikerne/',
      );
    case 'coop':
      return linkPath('/privat/coop');
    case 'danskeBank':
      return linkPath('/privat/danske-bank');
    case 'huseierne':
      return linkPath('/privat/samarbeidsavtaler/huseierne');
    default:
      return linkPath('/privat/forsikring/kjop-flere-forsikringer/');
  }
}
